var React = require('react');

function Account (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8","cy":"5.95996","r":"4","stroke":"white","strokeWidth":"2","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14 17.96H16C16 13.5417 12.4183 9.95996 8 9.95996C3.58172 9.95996 0 13.5417 0 17.96H2C2 14.6463 4.68629 11.96 8 11.96C11.3137 11.96 14 14.6463 14 17.96Z","fill":"white","key":1})]);
}

Account.defaultProps = {"width":"16","height":"18","viewBox":"0 0 16 18","fill":"none"};

module.exports = Account;

Account.default = Account;
